module.exports = __webpack_public_path__ + "static/media/rosh-hashana.8ccaf130.svg";